import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { selector, can } from "../../../api";
import { EditKayaContent } from "../../kaya/kaya/edit";
import { AddKaya } from "../../kaya/kaya/modal";
import { buildingCRUD } from "../../../actions/building";
import { Footer } from "../../../layout/footer";
import { Loading } from "../../constant";
import { EditBuilding } from "../edit";

export const BuildingKayaContent = () => {
  let location = useLocation();
  const user = selector.User();

  const [dataId] = useState(location.state.id);
  const [value, setValue] = useState("");
  const [data, setData] = useState({});
  const [kaya, setKaya] = useState([]);
  const [fitered, setFiltered] = useState([]);
  const [index, setIndex] = useState(0);
  const [dataIdId, setDataIdId] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      buildingCRUD
        .loadBuildingDetail(dataId)
        .then((resp) => {
          setData(resp.data);
          setKaya(resp.data.building_kaya);
        })
        .finally(() => { });
    }, 2000);
  }, [dataId, index]);

  const handleValueChange = (events) => {
    const sel = events.target.value;
    setValue(sel);
    const data = kaya.filter((entry) =>
      Object.values(entry.kaya_id).some(
        (val) =>
          typeof val === "string" &&
          val.toLowerCase().includes(sel.toLowerCase())
      )
    );
    setFiltered(data);
  };

  const handleChangeId = (e) => {
    setDataIdId(e);
  };

  const results = !value ? kaya : fitered;

  // Check if user can edit (group 2 or locality users)
  // Capability-based gate (replaces legacy group-id === 2 check).
  const canEdit = can(user, 'edit_data') || user?.admin_access === 'Shehia';

  return (
    <>
      <AddKaya setIndex={setIndex} index={index} buildingId={dataId} />
      <EditKayaContent dataId={dataIdId} setIndex={setIndex} index={index} />
      <EditBuilding dataId={dataId} index={index} setIndex={setIndex} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Building Details</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={"/building"}>Building</Link>
                      </li>
                      <li className="breadcrumb-item active">Details</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div
                    className="card-header"
                    data-bs-toggle="collapse"
                    data-bs-target=".close"
                  >
                    <div className="row">
                      <div className="col-sm">
                        <h4 className="card-title mt-3">Building</h4>
                      </div>
                      <div className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body close">
                    <div id="customerList">
                      <div className="row g-4 mb-3">
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Building Name
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={data.name ? data.name : "N/A"}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Building Type
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              placeholder="Enter your name"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              BRN
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={data.brn ? data.brn : "N/A"}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Postcode
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.boundary_id
                                  ? data.boundary_id.boundary_code
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              House Number
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={data.postcode ? data.postcode : "N/A"}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Shehia Number
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={data.house_no ? data.house_no : "N/A"}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row g-4 mb-3">
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Electricity Meter No
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.elecricity_meter_no
                                  ? data.elecricity_meter_no
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Water Meter No
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.water_meter_no
                                  ? data.water_meter_no
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Number of Units
                            </label>
                            <input
                              type="number"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.number_of_units ? data.number_of_units : 1
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Number of Floors
                            </label>
                            <input
                              type="number"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.number_of_floors
                                  ? data.number_of_floors
                                  : 1
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Shehia
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data.boundary_id
                                  ? data.boundary_id.boundary_name
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div
                            className="form-check form-switch form-switch-lg form-switch-success"
                            style={{ marginTop: 30, marginLeft: 20 }}
                            dir="ltr"
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={data.is_condominium ? true : false}
                              id="customSwitchsizelg"
                            />
                            <label
                              className="form-check-label"
                              for="customSwitchsizelg"
                            >
                              Condominium
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className="btn btn-soft-warning"
                          to={"/new"}
                          data-bs-toggle="modal"
                          data-bs-target=".editModal"
                        >
                          <i className="bi bi-pencil-square"></i> Edit
                        </Link>
                        <ul className="pagination listjs-pagination mb-0"></ul>
                        <Link
                          className="btn btn-soft-success"
                          to={"/map"}
                          state={{ type: "building", id: data.id }}
                        >
                          <i className="bi bi-geo-alt"></i> Map
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-sm">
                        <h4 className="card-title mt-3">House Hold</h4>
                      </div>
                      <div className="col-sm">
                        {canEdit && (
                          <div className="row d-flex justify-content-end">
                            <div className="col-auto">
                              <Link
                                to={"/new"}
                                className="btn btn-soft-primary"
                                data-bs-toggle="modal"
                                data-bs-target=".bs-example-modal-lg"
                              >
                                <i className="bi bi-plus-circle bi-lg"></i>{" "}
                                &nbsp; New House Hold
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              value={value}
                              onChange={handleValueChange}
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body tableFixHead">
                    <table
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>SR No.</th>
                          <th>House Hold Head</th>
                          <th>Members</th>
                          <th>Head Phone Number</th>
                          <th>Postcode</th>
                          <th>House Number</th>
                          <th>Shehia Number</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {results?.map((dt, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              {dt.kaya_id.head_name
                                ? dt.kaya_id.head_name.toUpperCase()
                                : "N/A"}
                            </td>
                            <td>
                              <span className="badge bg-info">
                                {dt.kaya_id.member_count ?? 0}
                              </span>
                            </td>
                            <td>
                              {dt.kaya_id.head_phone_number
                                ? dt.kaya_id.head_phone_number
                                : "N/A"}
                            </td>
                            <td>
                              {dt.kaya_id.postcode ? dt.kaya_id.postcode : "N/A"}
                            </td>
                            <td>
                              {dt.kaya_id.house_no ? dt.kaya_id.house_no : "N/A"}
                            </td>
                            <td>
                              {data?.boundary_id?.boundary_name
                                ? data.boundary_id.boundary_name
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              <div className="dropdown d-inline-block">
                                <button
                                  className="btn btn-soft-secondary btn-sm dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-fill align-middle"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <Link
                                      to={"/kayamember"}
                                      state={{ id: dt.kaya_id.id }}
                                      className="dropdown-item"
                                    >
                                      <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                                      View
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={"/new"}
                                      onClick={() =>
                                        handleChangeId(dt.kaya_id.id)
                                      }
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#editKaya"
                                      className="dropdown-item edit-item-btn"
                                    >
                                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                      Edit
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={"/map"}
                                      state={{ type: "building", id: data.id }}
                                      className="dropdown-item remove-item-btn"
                                    >
                                      <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                      Map
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="row">{!results.length && <Loading />}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
